import {
  useFundingProgramAbbr,
  useFundingProgramProperties,
  useSession,
} from "@outschool/ui-auth";

type UseConcierge = {
  canAccessConcierge: boolean;
};

export default function useConcierge(): UseConcierge {
  const { currentUser, isLoggedIn } = useSession();

  const esaState = useFundingProgramAbbr();
  const { findByAbbreviation } = useFundingProgramProperties();
  const fundingProgramProperties = findByAbbreviation(esaState);
  const isClassWalletProgram = fundingProgramProperties?.isClassWallet;

  const canAccessConcierge =
    isLoggedIn &&
    (currentUser?.hasSubscription ||
      currentUser?.hasEsaMembership ||
      isClassWalletProgram);

  return {
    canAccessConcierge: !!canAccessConcierge,
  };
}
